import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { EcmService } from '../../ecm.service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';

interface EcmUploadPartsData {
  toolNo: string;
  toolId: number;
  programId: number;
}

@Component({
  selector: 'ecm-upload-parts',
  templateUrl: './ecm-upload-parts.component.html',
})
export class EcmUploadPartsComponent implements OnInit {

  uploading = false;

  tool: EcmUploadPartsData;
  uploadedFile: any[];
  constructor(
    private readonly dialogRef: MatDialogRef<EcmUploadPartsComponent>,
    private readonly ecmService: EcmService,
    private readonly toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) private readonly data: EcmUploadPartsData
  ) { }

  ngOnInit() {
    this.tool = this.data;
  }

  upload(event: any) {
    this.uploadedFile = event.files;
    if (this.uploadedFile.length <= 0) {
      this.toastr.error('Please select a file to upload.');
      return;
    }

    this.uploading = true;

    const file: File = this.uploadedFile[0];
    this.ecmService.uploadParts(this.tool.toolId, this.tool.programId, file)
      .pipe(finalize(() => this.uploading = false))
      .subscribe(
        () => this.dialogRef.close(),
        (err) => this.toastr.error(err, 'Failed to upload file.')
      );
  }
}
